<div class="container  container-walai" style="margin-top: 60px!important;">
  <h1 class="w-100 h1-main" >OPAC Ultimate Version</h1>

  <div
    class="row row-cols-12 "
>
<div class="bd-example">
  <dl>
    <dt>16 Jul 2024</dt>
    <dd>1. Update Angular Version (V.17).</dd>
  </dl>
  <dl>
    <dt>17 Jul 2023</dt>
    <dd>1. Add word suggester.</dd>
    <dd>2. Add keyword opertors (AND, OR, NOT).</dd>
    <dd>3. Add keyword type in Book search.</dd>
    <dd>4. Add Share Facebook.</dd>
  </dl>
  <dl>
    <dt>03 Jul 2023</dt>
    <dd>1. Add Tag cloud.</dd>
    <dd>2. Add suggest friend.</dd>
  </dl>
  <dl>
    <dt>15 June 2023</dt>
    <dd>1. Fix bug check valid bib parameter.</dd>
    <dd>2. Add export MARC ISO2709.</dd>
    <dd>3. Add admin dashboard.</dd>
    <dd>4. Add bookCover from another source.</dd>
  </dl>
  <dl>
    <dt>22 May 2023</dt>
    <dd>1. Fix bug check cover image url.</dd>
    <dd>2. Fix bug Delivery service.</dd>
  </dl>
  <dl>
    <dt>29 Nov 2022</dt>
    <dd>1. Fix bug Hold function in bibitem.</dd>
    <dd>2. Display less item in bibitem.</dd>
  </dl>
  <dl>
    <dt>3 March 2022</dt>
    <dd>1. Fix bug logo size.</dd>
    <dd>2. Add Delivery service.</dd>
    <dd>3. Add Virtual Bookshelf service.</dd>
  </dl>

  <dl>
    <dt>15 June 2022</dt>
    <dd>1. Fix bug logo size.</dd>
    <dd>2. Add delivery service.</dd>
    <dd>3. Add Virtual Bookshelf service.</dd>
  </dl>

  <dl>
    <dt>15 May 2024</dt>
    <dd>1. Fix bug.</dd>
    <dd>2. Update Cookie consent.</dd>
  </dl>

  <dl>
    <dt>30 May 2024</dt>
    <dd>1. Fix bug.</dd>
    <dd>2. Update the default book cover image.</dd>
  </dl>

  <dl>
    <dt>1 April 2025</dt>
    <dd>1. Fix bug.</dd>
  </dl>

  <dl>
    <dt>8 May 2025</dt>
    <dd>1. Fix bug.</dd>
    <dd>2. Update interface profile</dd>
    <dd>3. Add function update PIN (Self check in)</dd>
  </dl>

  <dl>
    <dt>28 May 2025</dt>
    <dd>1. Add function privilege</dd>
    <dd>2. Add function curriculum resources</dd>
  </dl>

  <dl>
    <dt>9 June 2025</dt>
    <dd>1. Update API endpoint configuration.</dd>
    <dd>2. Refactor configuration structure.</dd>
  </dl>

   <dl>
    <dt>20250702.1.2.30</dt>
    <dd>1. Fix Delivery resource.</dd>
    <dd>2. Update UI.</dd>
  </dl>

   <dl>
    <dt>20250703.1.2.31</dt>
    <dd>1. Update security authentication.</dd>
  </dl>

   <dl>
    <dt>20250703.1.2.32</dt>
    <dd>1. Fix function curriculum resources.</dd>
  </dl>

  <dl>
    <dt>20250703.1.2.33</dt>
    <dd>1. Update security authentication.</dd>
  </dl>
  <dl>
    <dt>20250714.1.2.34</dt>
    <dd>1. Update security authentication.</dd>
    <dd>2. Fix resource delivery.</dd>
  </dl>

  <dl>
    <dt>20252214.1.2.35</dt>
    <dd>1. Add Refinded search.</dd>
    <dd>2. Location order by name A-Z.</dd>
    <dd>3. Facet order by A-Z.</dd>
    <dd>4. Facet year add textinput from to.</dd>
    <dd>5. Bug fix editor icon.</dd>
  </dl>

  
  <dl>
    <dt>20250731.1.2.36</dt>
    <dd>1. Update responsive.</dd>
    <dd>2. Fix function.</dd>
  </dl>

  <dl>
    <dt>20250801.1.2.37</dt>
    <dd>1. Update responsive.</dd>
  </dl>
  <dl>
    <dt>20250802.1.2.38</dt>
    <dd>1. Fix bug.</dd>
  </dl>
  <dl>
    <dt>20250802.1.2.39</dt>
    <dd>1. Fixed the way the RD button display was checked.</dd>
  </dl>
  <dl>
    <dt>20250822.1.2.40</dt>
    <dd>1. Fix bug.</dd>
  </dl>
  <dl>
    <dt>20250902.1.2.41</dt>
    <dd>1. Fix bug.</dd>
    <dd>2. Update config.</dd>
  </dl>
  <dl>
    <dt>20250908.1.2.42</dt>
    <dd>1. Fix bug RD services.</dd>
  </dl>
  <dl>
    <dt>20250925.1.2.44</dt>
    <dd>1. Fix bug RD services.</dd>
    <dd>2. Fix bug Curriculum resources services.</dd>
  </dl>
  <dl>
    <dt>20251002.1.2.45</dt>
    <dd>1. Update Function authentication.</dd>
    <dd>2. Update Google analytics.</dd>
  </dl>
  <dl>
    <dt>20251028.1.2.46</dt>
    <dd>1. Fix bug.</dd>
  </dl>
  <dl>
    <dt>20251124.1.2.47</dt>
    <dd>1. Fix bug.</dd>
  </dl>
  <dl>
    <dt>20260106.1.2.48</dt>
    <dd>1. Fix bug.</dd>
  </dl>
  <dl>
    <dt>20260120.1.2.49</dt>
    <dd>1. Fix bug.</dd>
  </dl>

</div>
  </div>
</div>
